import React, {useEffect, useState} from 'react'
import Loading from 'components/Loading';
import MoreButton from "components/button/MoreButton";
import RfxOfferService from "services/RfxOfferService";
import OfferTable from "./components/OfferTable";
import StatisticsService from "services/StatisticsService";
import useSearch, {getPaginationConfig} from "hooks/useSearch";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";
import GridBlock from "../../GridBlock";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Tr from "translations/Translations";
import RegisterEnvelopePopup from "./components/envelope/RegisterEnvelopePopup";
import {connect} from "react-redux";
import PropTypes from 'prop-types'
import BasicSearch from "components/BasicSearch";
import SplitButton, {createButton as createSplitButton} from "../../popup/components/SplitButton";
import {makeStyles} from "@material-ui/core";
import useSalesNotification from "../../../hooks/useSalesNotification";
import salesNotificationKeys from "../../popup/salesNotification/constants/salesNotification.keys";
import UpdateBindWithTheOfferDatePopup from "./components/UpdateBindWithTheOfferDatePopup";

const useStyle = makeStyles(theme => ({
    root: {}
}));

function Offers(
    {
        demandId,
        demandStatistics,
        currentRfxRound,
        offers,
        offersActions,
        demandHeader,
        validationCallback,
    }) {

    const classes = useStyle();
    const [offerLoading, setOfferLoading] = useState(true);
    const [registerEnvelopePopupOpened, setRegisterEnvelopePopupOpened] = useState(0);
    const [updateBindWithTheOfferDatePopupOpened, setUpdateBindWithTheOfferDatePopupOpened] = useState(false);
    const [downloadWorking, setDownloadWorking] = useState(false);
    const {searchData, totalCount, setTotalCount, setPaginationConfig, setSearchConfig} = useSearch();

    const refreshCurrentRows = () => {
        setOfferLoading(true);
        const loadedRows = offers.items.length;
        const {pagination} = searchData;
        let curPageSize = loadedRows < pagination.pageSize ? pagination.pageSize : loadedRows;
        RfxOfferService.getOffers(currentRfxRound.id, getPaginationConfig(1, curPageSize)).then(() => setOfferLoading(false));
    }

    useEffect(() => {
        if (!!offers && !!demandStatistics) {
            if (offers.totalCount !== demandStatistics.numberOfOffers) {
                refreshCurrentRows();
            }
        }
        //na 2 etapie ma wczytywać gdy zmieni się liczba ofert, na 3 etapie to nie powinno się odpalać.
        // eslint-disable-next-line
    }, [demandStatistics])


    useEffect(() => {
        if (currentRfxRound?.id)
            RfxOfferService.getAvailableActions(currentRfxRound.id);
        return () => {
            RfxOfferService.clearResources(RfxOfferService.RESOURCE_ID_RFX_OFFER_LIST)
            RfxOfferService.clearResources(RfxOfferService.RESOURCE_ID_RFX_OFFERS_ACTIONS)
        }
    }, [demandId, currentRfxRound?.id])

    useEffect(() => {
        if (currentRfxRound?.id) {
            setOfferLoading(true);
            const {pagination, search} = searchData;
            RfxOfferService.getOffers(currentRfxRound.id, pagination, search).then(() => (setOfferLoading(false)));
        }
        // eslint-disable-next-line
    }, [searchData, currentRfxRound?.id])

    useDidUpdateEffect(() => {
        if (offers?.totalCount !== undefined) {
            setTotalCount(offers.totalCount)
        }
    }, [offers?.totalCount]);


    const runDownload = (type) => {
        setDownloadWorking(true);
        if (type === 'attachments')
            RfxOfferService.downloadOffersAttachments(currentRfxRound.id, () => setDownloadWorking(false))
        else
            RfxOfferService.downloadOffersSummary(currentRfxRound.id, type, () => setDownloadWorking(false))
    }

    const runVerify = () => {
        setDownloadWorking(true);
        RfxOfferService.verifyOffersAttachments(currentRfxRound.id, () => setDownloadWorking(false))
    }

    const printVerificationSalesCheck = useSalesNotification(salesNotificationKeys.SIGNATURE_VERIFICATOR, () => runVerify(), downloadWorking);

    const getAdditionalButtons = () => {
        const buttons = [];
        if (offersActions.verifyAttachments)
            buttons.push(createSplitButton(offersActions.verifyAttachments.name, printVerificationSalesCheck, downloadWorking));
        if (offersActions.attachments)
            buttons.push(createSplitButton(offersActions.attachments.name, () => runDownload('attachments'), downloadWorking));
        if (offersActions.itemSummaryXls)
            buttons.push(createSplitButton(offersActions.itemSummaryXls.name, () => runDownload('item'), downloadWorking));
        if (offersActions.itemParametersXls)
            buttons.push(createSplitButton(offersActions.itemParametersXls.name, () => runDownload('itemParameters'), downloadWorking));
        if (offersActions.summaryXls)
            buttons.push(createSplitButton(offersActions.summaryXls.name, () => runDownload('xls'), downloadWorking));
        if (offersActions.summaryPdf)
            buttons.push(createSplitButton(offersActions.summaryPdf.name, () => runDownload('pdf'), downloadWorking));
        if (offersActions.updateBindWithTheOfferDate)
            buttons.push(createSplitButton(offersActions.updateBindWithTheOfferDate.name, () => setUpdateBindWithTheOfferDatePopupOpened(true), false));
        return (<SplitButton buttonClassName={classes.buttonPrint}
                             working={downloadWorking}
                             buttons={buttons}
                             variant="outlined"
                             hideEmpty
                             label={Tr('additional_actions')}
        />)
    }


    const getButtons = () => {
        const buttons = [];
        if (offersActions.envelope)
            buttons.push(createButton(offersActions.envelope.name, () => setRegisterEnvelopePopupOpened(-1), undefined));
        return (<MultiButton buttons={buttons} after={getAdditionalButtons()}/>)
    };

    if (!offers || !offersActions || !currentRfxRound) return <Loading/>

    return (
        <>
            <GridBlock justify='space-between'>
                <BasicSearch
                    label={Tr('search_supplier')}
                    searchInProgress={offerLoading}
                    doSearch={setSearchConfig}/>
                {getButtons()}
            </GridBlock>


            <OfferTable
                demandId={demandId}
                currentRfxRound={currentRfxRound}
                offers={offers}
                openEnvelopeEdit={(envelopeId) => setRegisterEnvelopePopupOpened(envelopeId)}
                demandHeader={demandHeader}
            />

            <MoreButton
                config={searchData.pagination}
                setConfig={setPaginationConfig}
                totalCount={totalCount}
                loadedCount={offers.items.length}
                captionTrKey='showing_x_of_y_suppliers'
                disabled={offerLoading || !(currentRfxRound?.id)}
            />

            {!!registerEnvelopePopupOpened &&
            <RegisterEnvelopePopup
                demandId={demandId}
                rfxRoundId={currentRfxRound.id}
                envelopeId={registerEnvelopePopupOpened}
                onClose={(cancel) => {
                    if (!cancel)
                        refreshCurrentRows();
                    setRegisterEnvelopePopupOpened(0);
                }}/>}

            {updateBindWithTheOfferDatePopupOpened &&
                <UpdateBindWithTheOfferDatePopup
                    demandId={demandId}
                    rfxRound={currentRfxRound}
                    onClose={() => {
                        setUpdateBindWithTheOfferDatePopupOpened(false);
                    }}
                    onUpdate={validationCallback}/>}
        </>
    )
}

Offers.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    downloadOffers: PropTypes.bool,
    registerEnvelope: PropTypes.bool
}

export default connect((state) => ({
    offers: state.resources[RfxOfferService.RESOURCE_ID_RFX_OFFER_LIST],
    offersActions: state.resources[RfxOfferService.RESOURCE_ID_RFX_OFFERS_ACTIONS],
    demandStatistics: state.resources[StatisticsService.DEMAND_STATISTICS_RESOURCE_ID],
    currentRfxRound: state.resources[StatisticsService.CURRENT_RFX_RESOURCE_ID],
    demandHeader: state.resources.demandHeader,
}), {})(Offers);